import { ApiProperty } from '@nestjs/swagger';
import { OffsetPaginationResponseDto } from '@sphere/shared/domain';
import { TemplateListItemResponseDto } from './template-list-item.response';

export class TemplateListResponseDto extends OffsetPaginationResponseDto<TemplateListItemResponseDto> {
  @ApiProperty({ type: () => [TemplateListItemResponseDto] })
  declare data: TemplateListItemResponseDto[];
}

